export default __webpack_public_path__ + "static/O0272-bd9dd290456d06f8641697395d3828f8.png";